import { render, staticRenderFns } from "./adminExternalRequest.vue?vue&type=template&id=203374d6"
import script from "./adminExternalRequest.vue?vue&type=script&lang=js"
export * from "./adminExternalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports